<template>
	<div>
		<!-- 推荐链接弹框 -->
		<el-dialog width="423px" :visible.sync="show" :append-to-body="true" @close="close()" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="link_dialog">
				<div class="link_top_close">
					<img @click="close()" class="link_dialog_close_icon" src="../../../assets/icons/close_icon2.png"
						alt="" />
				</div>
				<div class="link_dialog_title">
					<img class="link_dialog_title_img" src="../../../assets/icons/link_title1.png" alt="" />
					<img class="link_dialog_title_img mar_t15" src="../../../assets/icons/link_title2.png" alt="" />
				</div>
				<div class="link_dialog_from">
					<div class="link_dialog_from_item">
						<div class="link_dialog_from_item_input">
							{{user.userCode}}
						</div>
						<div @click="$use.copy(user.userCode)" class="link_dialog_from_item_btn">
							Copy
							<img class="link_dialog_copy_icon" src="../../../assets/icons/copy_icon2.png" alt="" />
						</div>
					</div>
					<div class="link_dialog_from_item mar_t10">
						<div class="link_dialog_from_item_input">
							{{ $shareUrl }}/{{ user.userCode }}
						</div>
						<div @click="$use.copy(`${$shareUrl}/${user.userCode}`)"
							class="link_dialog_from_item_btn">
							Copy
							<img class="link_dialog_copy_icon" src="../../../assets/icons/copy_icon2.png" alt="" />
						</div>
					</div>
				</div>
				<!-- <div class="link_share">
					<div class="link_share_icon" v-for="item in medialList" @click="clickShare(item)" :key="item.id">
						<img :src="item.mediaIcon" class="link_share_icon" alt="" />
					</div>
				</div> -->
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		mapState,
	} from 'vuex';

	export default {
		name: 'recommendLinkDialog',
		computed: {
			...mapState(['user', 'token', 'selfType']), // 映射 user 模块下的 userInfo 状态
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				medialList:[]
			}
		},
		
		mounted() {
			this.getMediaList()
		},
		methods: {
			close() {
				this.$emit('close', false)
			},
			getMediaList(){
				this.$api.getList({}).then(res => {
					this.medialList = res.data
				})
			},
			clickShare(value){
				window.open(value.mediaUrl, '_blank', 'noopener,noreferrer');
			},
		},
	}
</script>


<style scoped lang="scss">
	.link_dialog {
		position: absolute;
		left: 0;
		top: 0;
		width: 423px;
		min-width: 437px;
		min-height: 340px;
		overflow-y: auto;
		background: #1F242F;
		border-radius: 10px;
		border: 1px solid;
		background-image: url('../../../assets/image/link_bg.png');
		background-repeat: no-repeat;
		background-size: contain;
		box-sizing: border-box;
		padding: 131px 21px 0;
	}

	.link_top_close {
		width: 43.38px;
		height: 100%;
		display: flex;
		align-items: center;
	}

	.link_dialog_close_icon {
		position: absolute;
		top: 20px;
		right: 20px;
		width: 43.38px;
		height: 28.92px;
		cursor: pointer;
	}

	.link_dialog_title {
		text-align: left;
	}

	.link_dialog_title_img {
		height: 20px;
		object-fit: cover;
	}

	.link_dialog_from {
		width: 100%;
		margin-top: 21px;
	}

	.link_dialog_from_item {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.link_dialog_from_item_input {
		flex: 1;
		width: 100%;
		height: 40px;
		text-align: left;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		padding: 0 17px;
		background-color: #161A22;
		border-radius: 5.77px;
		color: #FFFFFF;
		font-size: 14px;
	}

	.link_dialog_from_item_btn {
		width: 73px;
		height: 38px;
		background: linear-gradient(95deg, #B2EB14 0%, #17CB67 25%, #19AB89 100%);
		border-radius: 6px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 13px;
		color: #FFFFFF;
		margin-left: 8px;
		cursor: pointer;

	}

	.link_dialog_copy_icon {
		width: 17.3px;
		height: 17.3px;
		margin-left: 6px;
	}

	.link_share {
		width: 100%;
		height: 61px;
		margin-top: 13px;
		display: flex;
		align-items: center;
		justify-content: space-evenly;
	}

	.link_share_icon {
		width: 35px;
		height: 35px;
	}
</style>